if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedByMediaId = this.openedBy?.getAttribute('data-media-id');

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === openedByMediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${openedByMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector ? activeMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}